import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import ReactTable from 'react-table';
import { Select, Button, Grid } from 'semantic-ui-react';
import PropTypes from 'prop-types';

import { Dropzone } from 'Components/forms/Dropzone';

import 'Styles/components/fileimportheadermapgrid.less';

class FileImportHeaderMapGridContainer extends Component {
  static propTypes = {
    fileData: PropTypes.array.isRequired,
    onFileUpload: PropTypes.func.isRequired,
    clearData: PropTypes.func.isRequired,
    headerOptions: PropTypes.array.isRequired,
    defaultHeaders: PropTypes.array.isRequired,
    delimiter: PropTypes.string,
    onHeaderChange: PropTypes.func,
    title: PropTypes.string,
    requiredHeaders: PropTypes.array,
    disabledHeaders: PropTypes.array,
  };

  state = {
    headerValues: this.props.defaultHeaders,
    fileName: '',
  };

  componentDidMount() {
    const { fileName } = this.props;
    if (fileName.length > 0) {
      this.setState({ fileName });
    }
  }

  componentDidUpdate(prevProps) {
    const { delimiter } = this.props;
    if (delimiter !== prevProps.delimiter) {
      this.props.clearData();
    }
  }

  getHeaderValues = () => {
    return this.state.headerValues;
  };

  findLongestRow = data => {
    let max = 0;
    data.forEach(row => {
      if (row.length > max) {
        max = row.length;
      }
    });
    return max;
  };

  uploadFile = file => {
    this.props.onFileUpload(
      file,
      this.props.delimiter ? this.props.delimiter : ','
    );
  };

  onDrop = files => {
    this.uploadFile(files[0]);
    this.setState({ fileName: files[0].name });
  };

  getColumns = () => {
    const { fileData } = this.props;

    const max = this.findLongestRow(fileData);

    let cols = [];
    for (var i = 0; i < max; i++) {
      cols[i] = {
        Header: this.renderHeader(i),
        id: `Column ${i}`,
        accessor: this.getAccessor(i),
      };
    }
    return cols;
  };

  getAccessor = index => row => {
    return row[index];
  };

  getOnChange = index => (e, { value }) => {
    let updatedHeaderValues = this.state.headerValues;
    updatedHeaderValues[index] = value;
    this.setState({ headerValues: updatedHeaderValues });
    this.props.onHeaderChange(updatedHeaderValues);
  };

  getHeaderOptions = index => {
    const { headerOptions, requiredHeaders, disabledHeaders } = this.props;
    const { headerValues } = this.state;

    let filteredOptions = headerOptions.filter(option => {
      const foundIndex = headerValues.indexOf(option.value);
      const isEnabled = !disabledHeaders.includes(option.value);
      return (
        (option.value === -1 || foundIndex === -1 || foundIndex === index) &&
        isEnabled
      );
    });

    filteredOptions = filteredOptions.map(element => {
      element.origtext = element.text;
      if (requiredHeaders && requiredHeaders.indexOf(element.value) >= 0) {
        return {
          ...element,
          text: (
            <span>
              <strong>{element.text}</strong> (Required)
            </span>
          ),
          required: true,
        };
      }
      return element;
    });

    filteredOptions = filteredOptions.sort((a, b) => {
      if (a.value === -1) {
        return -1;
      }
      if (b.value === -1) {
        return 1;
      }
      if (a.required && !b.required) {
        return -1;
      }
      if (!a.required && b.required) {
        return 1;
      }
      if (a.origtext < b.origtext) {
        return -1;
      }
      if (a.origtext > b.origtext) {
        return 1;
      }
      return 0;
    });

    return filteredOptions;
  };

  renderHeader = index => {
    return (
      <Fragment>
        <Select
          fluid
          floating
          options={this.getHeaderOptions(index)}
          value={
            this.state.headerValues[index] ? this.state.headerValues[index] : -1
          }
          onChange={this.getOnChange(index)}
        />
      </Fragment>
    );
  };

  renderTable = fileData => {
    const { clearData } = this.props;

    return (
      <Grid>
        <Grid.Row>
          <Grid.Column>
            <label className={'pull-left'}>{this.state.fileName}</label>
            <Button
              className={'pull-right'}
              secondary
              size={'tiny'}
              onClick={() => this.setState({ headerValues: [] })}
            >
              Clear Mappings
            </Button>
            <Button
              className={'pull-right'}
              secondary
              size={'tiny'}
              onClick={clearData}
            >
              Select Another File
            </Button>
            <br />
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column>
            <ReactTable
              className={'import-grid-header'}
              columns={this.getColumns()}
              data={fileData}
              pageSize={10}
              minRows={10}
              pages={1}
              showPagination={false}
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  };

  render() {
    const { fileData, loading, title } = this.props;

    return (
      <Fragment>
        <Grid>
          <Grid.Row>
            <Grid.Column>
              <label className={'text-orange'}>{title}</label>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column>
              {fileData && fileData.length > 0 ? (
                this.renderTable(fileData)
              ) : (
                <Dropzone
                  accept=".csv,.txt"
                  activeClassName="file--dropzone--active"
                  className="file--dropzone"
                  multiple={false}
                  onDrop={this.onDrop}
                  disabled={loading}
                >
                  <p>
                    Drag and drop a file here <br />
                    <small>or click to select a file</small>.
                  </p>
                </Dropzone>
              )}
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {};
};

export const FileImportHeaderMapGrid = withRouter(
  connect(
    mapStateToProps,
    {}
  )(FileImportHeaderMapGridContainer)
);



// WEBPACK FOOTER //
// ./src/components/grids/FileImportHeaderMapGrid.js